/**
 * Parcel search tips (shown in the search box) and a light client check. The API resolves any
 * identifier exactly first, then by part (4+ characters); see docs/sprints/WMS-API.md.
 */
export const SYNTAX: { example: string; meaning: string }[] = [
  { example: 'ITC000000123', meaning: 'The Parcel ID (on the hub label)' },
  { example: 'JT0012345678', meaning: 'A courier waybill' },
  { example: 'ORD-88812', meaning: "The client's own reference" },
  { example: '106141412345678908', meaning: 'An SSCC (with or without (00))' },
  { example: 'E28011700000020F11110001', meaning: 'An RFID tag EPC or TID' },
  { example: '7778', meaning: 'Part of any of these (4+ characters)' },
];

/** Returns a plain-language problem with the query, or null when it looks fine. */
export function checkQuery(q: string): string | null {
  const text = q.trim();
  if (!text) return null;
  if (text.length > 100) return 'That is too long for an identifier. Paste only the code.';
  return null;
}
